function updateOffer(user, distributor) {
    return (
        user.BusinessDetails.Code === distributor.Code &&
        distributor.Offer &&
        (user.BusinessDetails.Offer.LinkedBusiness !== distributor.Offer.LinkedBusiness ||
            user.BusinessDetails.Offer.Regions !== distributor.Offer.Regions)
    );
}

function createNewUser(user, distributor) {
    return {
        ...user,
        BusinessDetails: {
            ...user.BusinessDetails,
            Offer: {
                ...user.BusinessDetails.Offer,
                LinkedBusiness: distributor.Offer.LinkedBusiness,
                Regions: distributor.Offer.Regions,
            },
        },
    };
}

function BusinessOffer({ user, Distributor, dispatch, saveUserToWeb }) {
    if (updateOffer(user, Distributor)) {
        const newUser = createNewUser(user, Distributor);
        dispatch(saveUserToWeb(newUser, true, false));
    }
}

export default BusinessOffer;
